import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBasket, LazyBox3d, LazyCreditCard, LazyCustomerSupport, LazyDocument, LazyGettingStarted, LazyHumidity, LazyLights, LazyOffice, LazySettings, LazyShop, LazySpaceship, LazySwitches, LazyTemperature, LazyWeather, LazyWifi, LazyAdminsConfirmAccountActivationDIalog, LazyAdminsConfirmDeleteialog, LazyAdminsCreateDialog, LazyArgonAlert, LazyArgonAvatar, LazyArgonBadge, LazyArgonButton, LazyArgonCheckbox, LazyArgonDropdown, LazyArgonInput, LazyArgonPagination, LazyArgonPaginationItem, LazyArgonProgress, LazyArgonRadio, LazyArgonSnackbar, LazyArgonSocialButton, LazyArgonSwitch, LazyArgonTextarea, LazyCoachTableBalance, LazyCoachTableSessions, LazyCoachTableTransfer, LazyConfirmDeleteDialog, LazyConfirmSuccessDialog, LazyContactUsChangeStatusDialog, LazyCustomInput, LazyCustomeSelect, LazyCustomerTableAppoinments, LazyCustomerTableCreateNewPassword, LazyCustomerTableRequests, LazyDataTable, LazyDiscountsForm, LazyDropDownIcons, LazyImageUploader, LazyModal, LazyPermisionsList, LazySessionChatMessages, LazySessionCoachInfo, LazySessionCustomerInfo, LazySessionDetails, LazySessionInfo, LazySessionLogs, LazySessionNotes, LazySessionRecordInfo, LazySessionReports, LazyWarningUnableToDeleteDialog, LazyAppointmentsCancelSessionDialog, LazyAppointmentsPostponeSessionRequestDialog, LazyAppointmentsSelectDurationDialog, LazyAppointmentsUpdateAppointmentDialog, LazyAppointmentsUpdateSessionDialog, LazyAuthConfirmDialog, LazyCancelReasonsCreateUpdateDialog, LazyCoachCategoriesCreateUpdateDialog, LazyCoachLevelsCreateUpdateDialog, LazyCoachAttachements, LazyCoachStatistics, LazyCoachTabAllCoaches, LazyCoachTabCoachesUnderReview, LazyCoachTabUnCompleteData, LazyCoachesRequestsList, LazyContactUsSubreasonUpdateDialog, LazyDashboardChart, LazyDashboardConsultationsCard, LazyDashboardSquareCard, LazyDashboardUsersCard, LazyDashboardStatisticsCard, LazyFaqCreateUpdateFaq, LazyFaqCategory, LazyPaymentDialog, LazyPaymentSessionsBalanceTab, LazyPaymentTabs, LazyPaymentTransfersTab, LazyRatesStatisticsCard, LazySettingsCoaches, LazySettingsContactUs, LazySettingsCreateSessionSettingsDialog, LazySettingsFinancialCommissions, LazySettingsGeneral, LazySettingsGeneralPassword, LazySettingsRoles, LazySettingsSessions, LazySettingsTax, LazySharedConfirmDeleteDialog, LazySharedConfirmDeleteRecycleDialog, LazySharedCustomDatePicker, LazySharedDataCard, LazySharedFreezeAccountDialog, LazySharedFullCalendar, LazySharedHeaderCard, LazySharedMultipleSelect, LazySharedTimePicker, LazySharedRecycleBin, LazyWarningReviewedCoachTab, LazyWarningReviewedCustomerTab, LazyWarningSendWarningMailDialog } from '#components'
const lazyGlobalComponents = [
  ["Basket", LazyBasket],
["Box3d", LazyBox3d],
["CreditCard", LazyCreditCard],
["CustomerSupport", LazyCustomerSupport],
["Document", LazyDocument],
["GettingStarted", LazyGettingStarted],
["Humidity", LazyHumidity],
["Lights", LazyLights],
["Office", LazyOffice],
["Settings", LazySettings],
["Shop", LazyShop],
["Spaceship", LazySpaceship],
["Switches", LazySwitches],
["Temperature", LazyTemperature],
["Weather", LazyWeather],
["Wifi", LazyWifi],
["AdminsConfirmAccountActivationDIalog", LazyAdminsConfirmAccountActivationDIalog],
["AdminsConfirmDeleteialog", LazyAdminsConfirmDeleteialog],
["AdminsCreateDialog", LazyAdminsCreateDialog],
["ArgonAlert", LazyArgonAlert],
["ArgonAvatar", LazyArgonAvatar],
["ArgonBadge", LazyArgonBadge],
["ArgonButton", LazyArgonButton],
["ArgonCheckbox", LazyArgonCheckbox],
["ArgonDropdown", LazyArgonDropdown],
["ArgonInput", LazyArgonInput],
["ArgonPagination", LazyArgonPagination],
["ArgonPaginationItem", LazyArgonPaginationItem],
["ArgonProgress", LazyArgonProgress],
["ArgonRadio", LazyArgonRadio],
["ArgonSnackbar", LazyArgonSnackbar],
["ArgonSocialButton", LazyArgonSocialButton],
["ArgonSwitch", LazyArgonSwitch],
["ArgonTextarea", LazyArgonTextarea],
["CoachTableBalance", LazyCoachTableBalance],
["CoachTableSessions", LazyCoachTableSessions],
["CoachTableTransfer", LazyCoachTableTransfer],
["ConfirmDeleteDialog", LazyConfirmDeleteDialog],
["ConfirmSuccessDialog", LazyConfirmSuccessDialog],
["ContactUsChangeStatusDialog", LazyContactUsChangeStatusDialog],
["CustomInput", LazyCustomInput],
["CustomeSelect", LazyCustomeSelect],
["CustomerTableAppoinments", LazyCustomerTableAppoinments],
["CustomerTableCreateNewPassword", LazyCustomerTableCreateNewPassword],
["CustomerTableRequests", LazyCustomerTableRequests],
["DataTable", LazyDataTable],
["DiscountsForm", LazyDiscountsForm],
["DropDownIcons", LazyDropDownIcons],
["ImageUploader", LazyImageUploader],
["Modal", LazyModal],
["PermisionsList", LazyPermisionsList],
["SessionChatMessages", LazySessionChatMessages],
["SessionCoachInfo", LazySessionCoachInfo],
["SessionCustomerInfo", LazySessionCustomerInfo],
["SessionDetails", LazySessionDetails],
["SessionInfo", LazySessionInfo],
["SessionLogs", LazySessionLogs],
["SessionNotes", LazySessionNotes],
["SessionRecordInfo", LazySessionRecordInfo],
["SessionReports", LazySessionReports],
["WarningUnableToDeleteDialog", LazyWarningUnableToDeleteDialog],
["AppointmentsCancelSessionDialog", LazyAppointmentsCancelSessionDialog],
["AppointmentsPostponeSessionRequestDialog", LazyAppointmentsPostponeSessionRequestDialog],
["AppointmentsSelectDurationDialog", LazyAppointmentsSelectDurationDialog],
["AppointmentsUpdateAppointmentDialog", LazyAppointmentsUpdateAppointmentDialog],
["AppointmentsUpdateSessionDialog", LazyAppointmentsUpdateSessionDialog],
["AuthConfirmDialog", LazyAuthConfirmDialog],
["CancelReasonsCreateUpdateDialog", LazyCancelReasonsCreateUpdateDialog],
["CoachCategoriesCreateUpdateDialog", LazyCoachCategoriesCreateUpdateDialog],
["CoachLevelsCreateUpdateDialog", LazyCoachLevelsCreateUpdateDialog],
["CoachAttachements", LazyCoachAttachements],
["CoachStatistics", LazyCoachStatistics],
["CoachTabAllCoaches", LazyCoachTabAllCoaches],
["CoachTabCoachesUnderReview", LazyCoachTabCoachesUnderReview],
["CoachTabUnCompleteData", LazyCoachTabUnCompleteData],
["CoachesRequestsList", LazyCoachesRequestsList],
["ContactUsSubreasonUpdateDialog", LazyContactUsSubreasonUpdateDialog],
["DashboardChart", LazyDashboardChart],
["DashboardConsultationsCard", LazyDashboardConsultationsCard],
["DashboardSquareCard", LazyDashboardSquareCard],
["DashboardUsersCard", LazyDashboardUsersCard],
["DashboardStatisticsCard", LazyDashboardStatisticsCard],
["FaqCreateUpdateFaq", LazyFaqCreateUpdateFaq],
["FaqCategory", LazyFaqCategory],
["PaymentDialog", LazyPaymentDialog],
["PaymentSessionsBalanceTab", LazyPaymentSessionsBalanceTab],
["PaymentTabs", LazyPaymentTabs],
["PaymentTransfersTab", LazyPaymentTransfersTab],
["RatesStatisticsCard", LazyRatesStatisticsCard],
["SettingsCoaches", LazySettingsCoaches],
["SettingsContactUs", LazySettingsContactUs],
["SettingsCreateSessionSettingsDialog", LazySettingsCreateSessionSettingsDialog],
["SettingsFinancialCommissions", LazySettingsFinancialCommissions],
["SettingsGeneral", LazySettingsGeneral],
["SettingsGeneralPassword", LazySettingsGeneralPassword],
["SettingsRoles", LazySettingsRoles],
["SettingsSessions", LazySettingsSessions],
["SettingsTax", LazySettingsTax],
["SharedConfirmDeleteDialog", LazySharedConfirmDeleteDialog],
["SharedConfirmDeleteRecycleDialog", LazySharedConfirmDeleteRecycleDialog],
["SharedCustomDatePicker", LazySharedCustomDatePicker],
["SharedDataCard", LazySharedDataCard],
["SharedFreezeAccountDialog", LazySharedFreezeAccountDialog],
["SharedFullCalendar", LazySharedFullCalendar],
["SharedHeaderCard", LazySharedHeaderCard],
["SharedMultipleSelect", LazySharedMultipleSelect],
["SharedTimePicker", LazySharedTimePicker],
["SharedRecycleBin", LazySharedRecycleBin],
["WarningReviewedCoachTab", LazyWarningReviewedCoachTab],
["WarningReviewedCustomerTab", LazyWarningReviewedCustomerTab],
["WarningSendWarningMailDialog", LazyWarningSendWarningMailDialog],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
